module.exports = __webpack_public_path__ + "static/media/logo-medium.82c8987a.png";